import { render, staticRenderFns } from "./PacoteStatus.vue?vue&type=template&id=4ccbc88b&"
import script from "./PacoteStatus.vue?vue&type=script&lang=js&"
export * from "./PacoteStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports